export const DEFAULT_RPC_URL = "https://rpc.walletconnect.com/v1";
